<template lang="pug">
    div
        //- p Given Value is {{ value }}
        List
            //- 用 sortedValue 顯示
            ListItem(v-for="item in sortedValue" :key="item.groupName")
                ListItemMeta(:title="item.groupName" :description="item.roleName")
                template(slot="action")
                    //- 用原本的 index 操作，避免排序後 index 錯亂
                    Button(@click="editGroupRole(item.groupName)") {{ $t("rcmtable.editText")}}
                    Button(@click="removeGroupRole(item.groupName)") {{ $t("rcmtable.deleteText")}}
            Button(@click="isAddGroupRoleModalShow = true") {{ $t("rcmtable.addTagText")}}
        Modal(v-model="isAddGroupRoleModalShow" title="Add group and role" :mask-closable="false")
            Form(ref="createForm" :model="addGroupRoleData" v-if="isAddGroupRoleModalShow")
                FormItem(prop="groupName")
                    FormSelect(
                        v-model="addGroupRoleData.groupName" 
                        :formData="addGroupRoleData" 
                        :formItem="groupNameSelectorOptions" 
                        style="width:200px")
                FormItem(prop="roleName")
                    FormSelect(
                        v-model="addGroupRoleData.roleName" 
                        :formData="addGroupRoleData" 
                        :formItem="roleNameSelectorOptions" 
                        style="width:200px")
            div(slot="footer")
                Button(@click="cancelAddGroupRole") {{$t('rcmtable.cancelText')}}
                Button(@click="confirmAddGroupRole") {{$t('rcmtable.confirmText')}}
        Modal(
            v-model="isEditGroupRoleModalShow"
            title="Edit role"
        )
            Form(ref="editForm" :model="editGroupRoleData" v-if="isEditGroupRoleModalShow")
                FormItem(prop="roleName")
                    FormSelect(
                        v-model="editGroupRoleData.roleName" 
                        :formData="editGroupRoleData" 
                        :formItem="roleNameSelectorOptions" 
                        style="width:200px"
                    )
            div(slot="footer")
                Button(@click="cancelEditGroupRole") {{$t('rcmtable.cancelText')}}
                Button(@click="confirmEditGroupRole") {{$t('rcmtable.confirmText')}}

</template>
<script>
import { getFormOptions } from "@/api/formoptions";
import FormSelect from "@/components/rcmTableFormItems/Select/index.js";
import { sortGroupRoles } from "@/libs/utils.js";

export default {
    name: "GroupRoleSelector",
    components: { FormSelect },
    props: {
        value: {
            default: () => []
        }
    },
    data() {
        return {
            isAddGroupRoleModalShow: false,
            isEditGroupRoleModalShow: false,
            addGroupRoleData: { groupName: "", roleName: "" },
            editGroupRoleData: { groupName: "", roleName: "" },
            editingGroupRoleIndex: 0,
            groupNameSelectorOptions: {
                placeholder: this.$i18n.t("domainsetting.groupName"),
                options: [],
                remoteOptions: async (queryValue, queryParams) => {
                    queryValue = queryValue || "*";
                    queryParams.groupNames = `*${queryValue}*`;
                    let queryString = new URLSearchParams(queryParams).toString();
                    let result = await getFormOptions(`groupnames?${queryString}`);
                    return result.data.options;
                },
                queryParamsFields: [],
                defaultVal: ""
            },
            roleNameSelectorOptions: {
                placeholder: this.$i18n.t("rolesmanage.roleName"),
                options: [],
                remoteOptions: async (queryValue, queryParams) => {
                    queryValue = queryValue || "*";
                    queryParams.roleName = `*${queryValue}*`;
                    let queryString = new URLSearchParams(queryParams).toString();
                    let result = await getFormOptions(`rolenames?${queryString}`);
                    return result.data.options;
                },
                queryParamsFields: [{ fieldName: "groupName", queryIf: (val) => val !== "" }],
                defaultVal: "",
            },
        };
    },
    computed: {
        // 顯示用：依 groupName 排序，但保留原本在 value 的索引
        sortedValue() {
            return sortGroupRoles(this.value);
        },
    },
    methods: {
        confirmAddGroupRole() {
            if (this.value.map((e) => e.groupName).includes(this.addGroupRoleData.groupName))
                return this.$Message.warning("Group exist");

            if (this.addGroupRoleData.roleName == "") return this.$Message.warning("Missing Role");
            this.addGroupRole();
        },
        addGroupRole() {
            this.value.push(Object.assign(this.addGroupRoleData, {}));
            this.cancelAddGroupRole();
        },
        cancelAddGroupRole() {
            this.isAddGroupRoleModalShow = false;
            this.addGroupRoleData = { groupName: "", roleName: "" };
            this.$emit("modalSubmitComplete");
        },
        confirmEditGroupRole() {
            this.isEditGroupRoleModalShow = false;
        },
        cancelEditGroupRole() {
            this.$refs.editForm.resetFields();
            this.isEditGroupRoleModalShow = false;
        },
        removeGroupRole(groupName) {
            const idx = this.value.findIndex((v) => v.groupName === groupName);
            this.value.splice(idx, 1);
        },
        editGroupRole(groupName) {
            const idx = this.value.findIndex((v) => v.groupName === groupName);

            this.editingGroupRoleIndex = idx;
            this.editGroupRoleData = this.value[idx];
            this.isEditGroupRoleModalShow = true;
        },
    },
    mounted() {},
    created() {},
    destroyed() {},
    beforeDestroy() {}
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/GroupsRoleSelector.vue